// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationMetadata } from './notification-metadata';
import {
    NotificationMetadataFromJSON,
    NotificationMetadataFromJSONTyped,
    NotificationMetadataToJSON,
    NotificationMetadataToJSONTyped,
} from './notification-metadata';

/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    dae_id: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    delivery_status?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    email_address?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    email_content?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    message?: string;
    /**
     * 
     * @type {NotificationMetadata}
     * @memberof Notification
     */
    metadata?: NotificationMetadata;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    notification_id: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    notification_type?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    read_status?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    sent_timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    study_id: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    subject?: string;
}

/**
 * Check if a given object implements the Notification interface.
 */
export function instanceOfNotification(value: object): value is Notification {
    if (!('dae_id' in value) || value['dae_id'] === undefined) return false;
    if (!('notification_id' in value) || value['notification_id'] === undefined) return false;
    if (!('sent_timestamp' in value) || value['sent_timestamp'] === undefined) return false;
    if (!('study_id' in value) || value['study_id'] === undefined) return false;
    return true;
}

export function NotificationFromJSON(json: any): Notification {
    return NotificationFromJSONTyped(json, false);
}

export function NotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notification {
    if (json == null) {
        return json;
    }
    return {
        
        'dae_id': json['dae_id'],
        'delivery_status': json['delivery_status'] == null ? undefined : json['delivery_status'],
        'email_address': json['email_address'] == null ? undefined : json['email_address'],
        'email_content': json['email_content'] == null ? undefined : json['email_content'],
        'message': json['message'] == null ? undefined : json['message'],
        'metadata': json['metadata'] == null ? undefined : NotificationMetadataFromJSON(json['metadata']),
        'notification_id': json['notification_id'],
        'notification_type': json['notification_type'] == null ? undefined : json['notification_type'],
        'read_status': json['read_status'] == null ? undefined : json['read_status'],
        'sent_timestamp': json['sent_timestamp'],
        'study_id': json['study_id'],
        'subject': json['subject'] == null ? undefined : json['subject'],
    };
}

export function NotificationToJSON(json: any): Notification {
    return NotificationToJSONTyped(json, false);
}

export function NotificationToJSONTyped(value?: Notification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dae_id': value['dae_id'],
        'delivery_status': value['delivery_status'],
        'email_address': value['email_address'],
        'email_content': value['email_content'],
        'message': value['message'],
        'metadata': NotificationMetadataToJSON(value['metadata']),
        'notification_id': value['notification_id'],
        'notification_type': value['notification_type'],
        'read_status': value['read_status'],
        'sent_timestamp': value['sent_timestamp'],
        'study_id': value['study_id'],
        'subject': value['subject'],
    };
}
